import React, { useEffect, useState } from 'react'
import { Row, Col, Card, CardBody, Media } from "reactstrap";
import { Link } from "react-router-dom";
import { postSubmitForm } from '../../helpers/forms_helper';
import OrderProductSections from '../../pages/Dashboard/OrderProductSections';
import FinishedProductOrdersInProcessForDashboard from '../../pages/Orders/Centre/FinishedProducts/FinishedProductOrdersInProcessForDashboard';
import WelcomeComp from '../../pages/Dashboard/WelcomeComp';

const DashboardForCKM = () => {

    useEffect(() => {
        loadProductOrderCounts();
        loadAllSections();
    }, [])

    const [allSections, setAllSections] = useState([]);
    const loadAllSections = async () => {
      let url = process.env.REACT_APP_BASEURL + "productsections/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        setAllSections(response.data);
      }
    };
  

    const [productOrderCounts, setAllProductOrderCounts] = useState();
    const loadProductOrderCounts = async () => {
      let url = process.env.REACT_APP_BASEURL + "productorders/order_counts";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        setAllProductOrderCounts(response.data);
      }
    };
    return (
        <>
             <Row>
             <Col md="5">
                  <WelcomeComp />
                </Col>
                     <Col md={7}>
                     <Row>
                     <Col md="3">
                        <Link to="/finished_products/new_orders">
                          <Card className="mini-stats-wid" style={{backgroundColor: "#e3f2fd",color:"#0d47a1",border:"1px solid #9eb3e8"}}>
                            <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                              <Media>
                                <Media body>
                                  <p
                                    className="fw-medium"
                                  >
                                    New
                                  </p>
                                  <h4
                                    className="mb-0"
                                    style={{ color: "#0d47a1" }}
                                  >
                                    {productOrderCounts &&
                                      productOrderCounts.placed_orders||0}
                                  </h4>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>

                      <Col md="3">
                        <Link to="/finished_products/urgent_orders">
                          <Card className="mini-stats-wid" style={{backgroundColor: "#ffebee",color:"#b71c1c",border:"1px solid #f7766f"}}>
                            <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                              <Media>
                                <Media body>
                                  <p className="fw-medium"
                                    // style={{ color: "white" }}
                                  >
                                    Urgent
                                  </p>
                                  <h4
                                    className="mb-0"
                                    style={{ color: "#b71c1c" }}
                                  >
                                    {productOrderCounts &&
                                      productOrderCounts.urgent_orders||0}
                                  </h4>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>

                      <Col md="3">
                        <Link to="/finished_products/orders_in_process">
                          <Card className="mini-stats-wid" style={{backgroundColor: "#fff8e1",color:"#f57f17",border:"1px solid #f7dc79"}}>
                            <CardBody  style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                              <Media>
                                <Media body>
                                  <p className="fw-medium">
                                    In Process
                                  </p>
                                  <h4
                                    className="mb-0"
                                    style={{ color: "#f57f17" }}
                                  >
                                    {productOrderCounts &&
                                      productOrderCounts.in_process_orders || 0}
                                  </h4>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>

                      <Col md="3">
                        <Link to="/finished_products/closed_orders">
                          <Card className="mini-stats-wid" style={{backgroundColor: "#e8f5e9",color:"#1b5e20", border:"1px solid #9dde81"}}>
                            <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                              <Media>
                                <Media body>
                                  <p
                                    className="fw-medium"
                                    // style={{ color: "white" }}
                                  >
                                    Closed
                                  </p>
                                  <h4
                                    className="mb-0"
                                    style={{ color: "#1b5e20" }}
                                  >
                                    {productOrderCounts &&
                                      productOrderCounts.closed_orders || 0}
                                  </h4>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                     </Row>
                     </Col>
                    </Row>
                    <Row>
                        <Col xl="12">
                      <OrderProductSections
                        sections={allSections && allSections}
                        heading="New Orders"
                        type="new_orders"
                      />
                    </Col>
                    <Col xl="12">
                      <OrderProductSections
                        sections={allSections && allSections}
                        heading="Orders in Process"
                        type="orders_in_process"
                      />
                    </Col>

                    <Col xl="12">
                      <OrderProductSections
                        sections={allSections && allSections}
                        heading="Closed Orders"
                        type="closed_orders"
                      />
                    </Col>
                    </Row>
                    <Row>
                  <FinishedProductOrdersInProcessForDashboard />
                </Row>
        </>
    )
}

export default DashboardForCKM